export default __webpack_public_path__ + "static/media/casual-senior-man-home-with-doctor.936c793a.jpg";